(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-new"] && !Shopify.designMode) return;
  try {
    
  function initializeSlideshow() {
    var container = document.querySelector('.announcement-bar-2');
    if (!container) return;

    var slides = Array.from(container.querySelectorAll('.announcement-slide'));
    if (slides.length === 0) return;

    if (window._announcementInterval) {
      clearInterval(window._announcementInterval);
      window._announcementInterval = null;
    }

    if (slides.length === 1) {
      slides[0].style.position = 'relative';
      slides[0].style.opacity = '1';
      slides[0].classList.add('active');
      return;
    }

    var slideDuration = parseInt(container.dataset.slideDuration, 10) || 5;
    var currentIndex = 0;

    function showSlide(index) {
      slides.forEach(function(s, i) {
        if (i === index) {
          s.style.opacity = '1';
          s.style.position = 'relative';
          s.classList.add('active');
        } else {
          s.classList.remove('active');
          s.style.opacity = '0';
          s.style.position = 'absolute';
        }
      });
    }

    showSlide(currentIndex);

    window._announcementInterval = setInterval(function() {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }, (slideDuration * 1000) + 200);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initializeSlideshow();
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(function() { initializeSlideshow(); }, 200);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
